import React, { useEffect, useState } from "react";
import { BellIcon } from "@heroicons/react/24/outline";
import { useAuth } from "../../../context/AuthContext";
import { getNotificationsApi } from "../../../services/axios/AuthApis/NotificationApis";

export default function NotificationsPanel({ frameworks, overdueCount, dueSoonCount, unassignedCount, onNotificationClick }) {
  const { user } = useAuth();
  const userId = user?.id || user?._id || null;
  const [auditorItems, setAuditorItems] = useState([]);

  useEffect(() => {
    if (!userId) return;
    let cancelled = false;
    getNotificationsApi(userId, { module: "compliance", page: 1, page_size: 20 })
      .then((data) => {
        if (cancelled) return;
        setAuditorItems(
          (data?.results || []).map((n) => ({
            key: `auditor-${n.id || n._id}`,
            message: n.message,
          })),
        );
      })
      .catch(() => {});
    return () => { cancelled = true; };
  }, [userId]);

  const lowest = frameworks
    .filter((f) => f.enabled && f.totalControls > 0)
    .sort((a, b) => a.score - b.score)[0];

  const items = [...auditorItems];
  if (overdueCount > 0) {
    items.push({
      key: "overdue",
      message: `${overdueCount} control${overdueCount === 1 ? "" : "s"} are overdue`,
      onClick: () => onNotificationClick({ card: "pending", flag: "overdue" }),
    });
  }
  if (dueSoonCount > 0) {
    items.push({
      key: "soon",
      message: `${dueSoonCount} control${dueSoonCount === 1 ? "" : "s"} due within 7 days`,
      onClick: () => onNotificationClick({ card: "pending", flag: "soon" }),
    });
  }
  if (unassignedCount > 0) {
    items.push({
      key: "unassigned",
      message: `${unassignedCount} control${unassignedCount === 1 ? "" : "s"} have no owner`,
      onClick: () => onNotificationClick({ card: "pending", tab: "unassigned" }),
    });
  }
  if (lowest && lowest.score < 50) {
    items.push({
      key: "lowest",
      message: `${lowest.name} is ${lowest.score}% complete`,
      onClick: () => onNotificationClick({ card: "enabled", frameworkId: lowest.id }),
    });
  }

  return (
    <div className="bg-red-50 rounded-2xl p-4 h-full flex flex-col border border-red-100">
      <div className="flex items-center justify-between mb-3">
        <h3 className="text-sm font-semibold text-gray-900">Compliance Notifications</h3>
        {items.length > 0 && (
          <span className="text-xs font-semibold bg-red-600 text-white rounded-full px-2 py-0.5">
            {items.length}
          </span>
        )}
      </div>

      {items.length === 0 ? (
        <div className="flex-1 flex flex-col items-center justify-center text-center text-gray-400">
          <BellIcon className="w-8 h-8 mb-2" />
          <p className="text-sm">No notifications yet.</p>
        </div>
      ) : (
        <div className="flex-1 overflow-y-auto space-y-2">
          {items.map((item) => (
            <button
              key={item.key}
              type="button"
              onClick={item.onClick}
              className="w-full text-left bg-white rounded-xl p-3 text-sm text-gray-800 shadow-sm hover:shadow-md transition-shadow focus:outline-none focus-visible:ring-2 focus-visible:ring-red-300"
            >
              {item.message}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
